(ns global.endor.checkout.ui.components.basics
  {:clj-kondo/config '{:linters {:unused-value {:level :off}}}}
  (:require [global.endor.checkout.ui.style.colors :as colors]
            [global.endor.checkout.ui.style.elements :as style]
            [uix.core :as uix :refer [$ defui]]))

(defn styles
  "Merges styles together into a single map.

   - When given a vector of styles, merges them all into a single map
   - When given a map, returns it unchanged
   - When given multiple arguments, combines them into a vector and processes

   Examples:
   (styles {:color 'red'})                    => {:color 'red'}
   (styles [{:color 'red'} {:padding 10}])    => {:color 'red' :padding 10}
   (styles {:color 'red'} {:padding 10})      => {:color 'red' :padding 10}"
  ([x]
   (cond (vector? x) (reduce merge (mapv styles x))
         (map? x) x))
  ([x & xs]
   (styles (into [x] xs))))

(defui row
  "Creates a horizontal layout component (row).

   Props:
   - style: Additional style overrides to apply
   - children: Child components to render
   - justify-content: Horizontal alignment ('flex-start', 'center', etc.)
   - align-items: Vertical alignment ('center', 'flex-start', etc.)
   - gap: Spacing between children (number or keyword like :small, :medium)"
  [{:keys [style children justify-content align-items gap]}]
  ($ :div
     {:style (styles
              {:display "flex"
               :flex-direction "row"
               :justify-content (or justify-content "flex-start")
               :align-items (or align-items "center")
               :gap (if (number? gap)
                      gap
                      (get-in style/gap [:left-right (or gap :medium)]))}
              style)}
     children))

(defui column
  "Creates a vertical layout component (column).

   Props:
   - style: Additional style overrides to apply
   - children: Child components to render
   - justify-content: Vertical alignment ('flex-start', 'center', etc.)
   - align-items: Horizontal alignment ('flex-start', 'center', etc.)
   - gap: Spacing between children (number or keyword like :small, :medium)"
  [{:keys [style children justify-content align-items gap]}]
  ($ :div
     {:style (styles
              {:display "flex"
               :flex-direction "column"
               :justify-content justify-content
               :align-items align-items
               :gap (if (number? gap)
                      gap
                      (get-in style/gap [:top-bottom (or gap :medium)]))}
              style)}
     children))

(defui text
  "Creates a text component with consistent styling.

   Props:
   - style: Additional style overrides to apply
   - children: Text content to display
   - font: Font style to use (:body, :h1, etc.)
   - color: Text color (string or keyword like :primary)"
  [{:keys [style children font color]}]
  ($ :div
     {:style (styles
              (style/font (or font :body))
              {:color (if (string? color)
                        color
                        (colors/text (or color :primary)))}
              style)}
     children))
